<template>
  <div id="data-list-list-view" class="data-list-container">
    <caso-sidebar v-if="addNewDataSidebar" :propModeView="sidebarViewMode" :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar" @refresh="updateTable" :data="sidebarData" />
  </div>
</template>

<script>

import CasoSidebar from '@/views/caso/CasoSidebar.vue'
import CasoModule from '@/store/caso-module/moduleDataList.js'

export default {
  components: {
    CasoSidebar
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    propModeView: {
      // Si es modo ver, se incluye el CasoView, sino CasoEdit
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      sidebarViewMode: true
    }
  },
  computed: {
  },
  created() {
    // Loading
    if (!CasoModule.isRegistered) {
      this.$store.registerModule('CasoModule', CasoModule)
      CasoModule.isRegistered = true
    }
    this.initValues()
  },
  watch: {
  },
  methods: {
    initValues() {
      this.$vs.loading()
      this.$store
        .dispatch('CasoModule/getCasoById', { id: this.$route.params.idRequest, idUser: this.$store.state.auth.userDetails().id })
        .then((response) => {
          this.$vs.loading.close()
          if (response) {
            this.sidebarData = response
            this.toggleDataSidebar(true)
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text:
                'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
              acceptText: 'Aceptar'
            })
          }
        })
        .catch((response) => {
          console.log('getCasoById response error,', response)
          this.$vs.loading.close()
          this.toggleDataSidebar(false)

          if (response.nuOK === 0 && response.request) {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text:
                'El código del caso no es correcto.',
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text:
                'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
              acceptText: 'Aceptar'
            })
          }

          this.goToHome()
        })
    },
    updateTable() {
      this.$vs.loading()
      this.$store
        .dispatch('CasoModule/getAllCasos', this.$store.state.auth.userDetails())
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()

          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text:
              'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
            acceptText: 'Aceptar'
          })
        })
    },
    goToHome() {
      this.$router.replace(`/${(this.$route.params.nameCompany)}`).catch(() => { })
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },
    activateEditMode() {
      this.propModeView = false
    },
    closeSidebar() {
      this.$emit('closeSidebar')
      this.$validator.reset()
      this.initValues()
    },
    refreshData() {
      this.$emit('refresh')
      this.$emit('closeSidebar')
      this.$validator.reset()
      this.initValues()
    }
  }
}
</script>

<style></style>
